/**
 * @generated SignedSource<<a0b9c203877ad4b3d9bbe7403fa39df7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type sidebarPreview_DeleteEventMutation$variables = {
  id: string;
};
export type sidebarPreview_DeleteEventMutation$data = {
  readonly deleteEvent: {
    readonly id: string;
  };
};
export type sidebarPreview_DeleteEventMutation = {
  response: sidebarPreview_DeleteEventMutation$data;
  variables: sidebarPreview_DeleteEventMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "sidebarPreview_DeleteEventMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Event",
        "kind": "LinkedField",
        "name": "deleteEvent",
        "plural": false,
        "selections": [
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "sidebarPreview_DeleteEventMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Event",
        "kind": "LinkedField",
        "name": "deleteEvent",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "filters": null,
            "handle": "deleteRecord",
            "key": "",
            "kind": "ScalarHandle",
            "name": "id"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "aeb08f0b3b3aa44cb75145deff44db10",
    "id": null,
    "metadata": {},
    "name": "sidebarPreview_DeleteEventMutation",
    "operationKind": "mutation",
    "text": "mutation sidebarPreview_DeleteEventMutation(\n  $id: ID!\n) {\n  deleteEvent(id: $id) {\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "7a69982a88c7f2868feaa6356721cca5";

export default node;
